export var IconButtonColor = {
  Primary: 'primary',
  Secondary: 'secondary',
  Basic: 'basic'
};